/**
 * ================================================================================
 * INFINITE SCROLL + FILTRO DE PREÇO NATIVO SHOPIFY (SERVER-SIDE)
 * ================================================================================
 * VERSÃO: 7.0 - Server-Side Price Filtering
 * DATA: 2025
 *
 * FUNCIONALIDADES:
 * ✅ Infinite scroll (carrega produtos automaticamente)
 * ✅ Filtro de preço via Shopify native filters (server-side, instantâneo)
 * ✅ Bloco de filtro ativo na sidebar
 * ✅ Mobile sidebar (open/close)
 *
 * COMO FUNCIONA:
 * Quando o utilizador aplica um filtro de preço, a página recarrega com
 * parâmetros URL nativos do Shopify:
 *   ?filter.v.price.gte=0&filter.v.price.lte=100
 * O Shopify filtra no servidor e devolve APENAS os produtos corretos.
 * O infinite scroll inclui esses parâmetros nas próximas páginas.
 *
 * PRÉ-REQUISITO:
 * O filtro de preço deve estar ativado no Shopify Admin:
 *   Apps > Search & Discovery > Filters
 * (Por defeito, o filtro de preço já vem ativado)
 * ================================================================================
 */

console.log('✅ infinite-scroll-filters.js v7.0 (Server-Side Filters) carregando...');

/* ============================================================================
   VARIÁVEIS GLOBAIS
   ============================================================================ */
var currentPage = 1;
var totalPages = 1;
var isLoading = false;
var hasMoreProducts = true;
var collectionUrl = '';

/* ============================================================================
   INICIALIZAÇÃO
   ============================================================================ */
document.addEventListener('DOMContentLoaded', function() {
  var paginationData = document.getElementById('collection-pagination-data');
  if (paginationData) {
    currentPage = parseInt(paginationData.dataset.currentPage) || 1;
    totalPages = parseInt(paginationData.dataset.totalPages) || 1;
    collectionUrl = paginationData.dataset.collectionUrl || '/collections/all';
    console.log('📄 Página ' + currentPage + ' de ' + totalPages + ' | URL: ' + collectionUrl);
  }

  setupInfiniteScroll();
  setupMobileFilters();
  restorePriceFilterUI();

  console.log('✅ Sistema pronto!');
});

/* ============================================================================
   HELPERS - URL PARAMETERS
   ============================================================================ */

/**
 * Obter parâmetros de filtro atuais da URL
 */
function getCurrentFilterParams() {
  var params = new URLSearchParams(window.location.search);
  var filterParams = new URLSearchParams();

  params.forEach(function(value, key) {
    if (key.indexOf('filter.') === 0) {
      filterParams.set(key, value);
    }
  });

  return filterParams;
}

/**
 * Construir URL com filtros + página
 */
function buildFilteredUrl(page) {
  var filterParams = getCurrentFilterParams();
  var url = collectionUrl;
  var allParams = new URLSearchParams();

  if (page && page > 1) {
    allParams.set('page', page);
  }

  filterParams.forEach(function(value, key) {
    allParams.set(key, value);
  });

  var paramString = allParams.toString();
  return paramString ? url + '?' + paramString : url;
}

/**
 * Verificar se há filtro de preço ativo na URL
 */
function isPriceFilterActive() {
  var params = new URLSearchParams(window.location.search);
  return params.has('filter.v.price.gte') || params.has('filter.v.price.lte');
}

/**
 * Obter valores do filtro de preço da URL
 */
function getPriceFilterValues() {
  var params = new URLSearchParams(window.location.search);
  return {
    min: params.get('filter.v.price.gte') ? parseFloat(params.get('filter.v.price.gte')) : null,
    max: params.get('filter.v.price.lte') ? parseFloat(params.get('filter.v.price.lte')) : null
  };
}

/* ============================================================================
   FILTRO DE PREÇO - SERVER-SIDE
   ============================================================================ */

/**
 * Aplicar filtro de preço (redireciona com parâmetros nativos Shopify)
 */
window.filterByPrice = function() {
  var minInput = document.getElementById('price-min');
  var maxInput = document.getElementById('price-max');

  var min = minInput && minInput.value ? parseFloat(minInput.value) : null;
  var max = maxInput && maxInput.value ? parseFloat(maxInput.value) : null;

  if (min === null && max === null) {
    alert('Por favor, introduz um valor mínimo ou máximo');
    return;
  }

  // Construir URL com filtros nativos Shopify
  var params = new URLSearchParams();

  // Manter outros filtros que possam existir
  var currentParams = new URLSearchParams(window.location.search);
  currentParams.forEach(function(value, key) {
    if (key.indexOf('filter.') === 0 && key !== 'filter.v.price.gte' && key !== 'filter.v.price.lte') {
      params.set(key, value);
    }
  });

  // Adicionar filtro de preço
  if (min !== null) {
    params.set('filter.v.price.gte', min.toString());
  }
  if (max !== null) {
    params.set('filter.v.price.lte', max.toString());
  }

  // Redirecionar - o Shopify filtra no servidor
  var newUrl = collectionUrl + '?' + params.toString();
  console.log('💰 Redirecionar com filtro de preço: ' + newUrl);
  window.location.href = newUrl;
};

/**
 * Limpar filtro de preço (remove parâmetros de preço da URL)
 */
window.clearPriceFilter = function() {
  var params = new URLSearchParams(window.location.search);

  params.delete('filter.v.price.gte');
  params.delete('filter.v.price.lte');

  var paramString = params.toString();
  var newUrl = paramString ? collectionUrl + '?' + paramString : collectionUrl;

  console.log('🧹 Limpar filtro de preço: ' + newUrl);
  window.location.href = newUrl;
};

/**
 * Restaurar UI do filtro de preço quando a página carrega com filtros na URL
 */
function restorePriceFilterUI() {
  if (!isPriceFilterActive()) return;

  var values = getPriceFilterValues();

  // Preencher inputs
  var minInput = document.getElementById('price-min');
  var maxInput = document.getElementById('price-max');
  if (minInput && values.min !== null) minInput.value = values.min;
  if (maxInput && values.max !== null) maxInput.value = values.max;

  // Mostrar botão limpar
  var clearBtn = document.querySelector('.price-clear-btn');
  if (clearBtn) clearBtn.style.display = 'block';

  // Mostrar bloco de filtro ativo
  showPriceFilterActiveBlock(values.min, values.max);

  console.log('💰 Filtro de preço restaurado: €' + (values.min || 0) + ' - €' + (values.max || '∞'));
}

/**
 * Mostrar bloco de filtro ativo na sidebar
 */
function showPriceFilterActiveBlock(min, max) {
  // Construir label
  var label = 'Preço: ';
  if (min !== null && max !== null) {
    label += '€' + formatPrice(min) + ' — €' + formatPrice(max);
  } else if (min !== null) {
    label += 'mín €' + formatPrice(min);
  } else if (max !== null) {
    label += 'máx €' + formatPrice(max);
  }

  // Criar bloco
  var container = document.createElement('div');
  container.id = 'active-price-filter';
  container.className = 'active-filters-section';
  container.style.display = 'block';
  container.innerHTML =
    '<div class="active-filters-title">Filtro de Preço Ativo:</div>' +
    '<div class="active-filters-tags">' +
      '<div class="active-filter-tag">' +
        label +
        '<span class="remove-filter" id="remove-price-filter" style="cursor:pointer;">×</span>' +
      '</div>' +
    '</div>' +
    '<button type="button" class="clear-all-btn" id="clear-price-filter-btn">Limpar Filtro de Preço</button>';

  // Inserir na sidebar antes das secções de filtros
  var sidebar = document.querySelector('.filters-sidebar');
  if (sidebar) {
    var firstFilterSection = sidebar.querySelector('.filter-section');
    if (firstFilterSection) {
      sidebar.insertBefore(container, firstFilterSection);
    } else {
      sidebar.appendChild(container);
    }
  }

  // Event listeners
  var removeBtn = document.getElementById('remove-price-filter');
  if (removeBtn) {
    removeBtn.addEventListener('click', function() {
      window.clearPriceFilter();
    });
  }

  var clearFilterBtn = document.getElementById('clear-price-filter-btn');
  if (clearFilterBtn) {
    clearFilterBtn.addEventListener('click', function() {
      window.clearPriceFilter();
    });
  }
}

/**
 * Formatar preço para display (ex: 1.5 → "1,50")
 */
function formatPrice(price) {
  return price.toFixed(2).replace('.', ',');
}

/* ============================================================================
   INFINITE SCROLL
   ============================================================================ */
function setupInfiniteScroll() {
  window.addEventListener('scroll', function() {
    if (isLoading || !hasMoreProducts) return;

    var scrollPosition = window.scrollY + window.innerHeight;
    var pageHeight = document.documentElement.scrollHeight;

    if (scrollPosition > pageHeight - 500) {
      loadMoreProducts();
    }
  });

  console.log('✅ Infinite scroll configurado');
}

/**
 * Carregar mais produtos (inclui filtros ativos automaticamente)
 */
function loadMoreProducts() {
  if (currentPage >= totalPages) {
    hasMoreProducts = false;
    showEndMessage();
    return;
  }

  isLoading = true;
  showLoadingSpinner();

  var nextPage = currentPage + 1;

  // Construir URL com filtros + próxima página
  var url = buildFilteredUrl(nextPage);

  console.log('🔄 Carregando página ' + nextPage + ': ' + url);

  fetch(url)
    .then(function(response) { return response.text(); })
    .then(function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newProducts = doc.querySelectorAll('#product-grid .grid__item');

      if (newProducts.length > 0) {
        var productGrid = document.getElementById('product-grid');
        newProducts.forEach(function(product) {
          productGrid.appendChild(product.cloneNode(true));
        });

        console.log('✅ ' + newProducts.length + ' produtos adicionados (página ' + nextPage + ')');
        currentPage = nextPage;

        // Atualizar contador
        var totalVisible = productGrid.querySelectorAll('.grid__item').length;
        updateProductCount(totalVisible);

        if (currentPage >= totalPages) {
          hasMoreProducts = false;
          showEndMessage();
        }
      } else {
        hasMoreProducts = false;
        showEndMessage();
      }

      hideLoadingSpinner();
      isLoading = false;
    })
    .catch(function(error) {
      console.error('❌ Erro ao carregar produtos:', error);
      hideLoadingSpinner();
      isLoading = false;
    });
}

/* ============================================================================
   UI HELPERS
   ============================================================================ */
function updateProductCount(count) {
  var countEl = document.getElementById('product-count');
  if (countEl) {
    countEl.innerHTML = '<strong>' + count + '</strong> ' +
      (count === 1 ? 'produto encontrado' : 'produtos encontrados');
  }
}

function showLoadingSpinner() {
  var s = document.getElementById('infinite-scroll-loading');
  if (s) s.classList.add('active');
}

function hideLoadingSpinner() {
  var s = document.getElementById('infinite-scroll-loading');
  if (s) s.classList.remove('active');
}

function showEndMessage() {
  var e = document.getElementById('infinite-scroll-end');
  if (e) e.classList.add('active');
}

/* ============================================================================
   MOBILE SIDEBAR
   ============================================================================ */
function setupMobileFilters() {
  var openBtn = document.getElementById('open-filters-mobile');
  var closeBtn = document.getElementById('close-filters-mobile');
  var overlay = document.getElementById('filters-mobile-overlay');

  if (openBtn) openBtn.addEventListener('click', openMobileFilters);
  if (closeBtn) closeBtn.addEventListener('click', closeMobileFilters);
  if (overlay) overlay.addEventListener('click', closeMobileFilters);

  console.log('✅ Mobile sidebar configurada');
}

function openMobileFilters() {
  var sidebar = document.getElementById('filters-mobile-sidebar');
  var overlay = document.getElementById('filters-mobile-overlay');
  if (sidebar) sidebar.classList.add('active');
  if (overlay) overlay.classList.add('active');
  document.body.classList.add('filters-mobile-open');
}

function closeMobileFilters() {
  var sidebar = document.getElementById('filters-mobile-sidebar');
  var overlay = document.getElementById('filters-mobile-overlay');
  if (sidebar) sidebar.classList.remove('active');
  if (overlay) overlay.classList.remove('active');
  document.body.classList.remove('filters-mobile-open');
}

/* ============================================================================
   FIM
   ============================================================================ */
console.log('✅ infinite-scroll-filters.js v7.0 carregado com sucesso!');